import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import LetterSpacing from './LetterSpacing';
import ClientProvider from './client';
export default createDemo(import.meta.url, LetterSpacing, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/system/typography/demos/letter-spacing/LetterSpacing.tsx",
    "fileName": "LetterSpacing.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import Typography from '@mui/material/Typography';\nimport Box from '@mui/material/Box';\n\nexport default function LetterSpacing() {\n  return (\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus",
            "dataFrameIndent": 2,
            "dataFrameFocusTarget": "",
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "    <Typography component=\"div\">\n      <Box sx={{ letterSpacing: 6, m: 1 }}>Letter Spacing 6px.</Box>\n      <Box sx={{ letterSpacing: 10, m: 1 }}>Letter Spacing 10px.</Box>\n    </Typography>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "  );\n}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 11,
        "focusedLines": 4,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import Typography from '@mui/material/Typography';\nimport Box from '@mui/material/Box';\n\nexport default function LetterSpacing() {\n  return (\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 2,
          "dataFrameFocusTarget": ""
        },
        "    <Typography component=\"div\">\n      <Box sx={{ letterSpacing: 6, m: 1 }}>Letter Spacing 6px.</Box>\n      <Box sx={{ letterSpacing: 10, m: 1 }}>Letter Spacing 10px.</Box>\n    </Typography>\n"
      ],
      [
        "span",
        "frame",
        "  );\n}\n"
      ]
    ],
    "fallbackCritical": {
      "1": [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 2,
          "dataFrameFocusTarget": ""
        },
        [
          [
            "span",
            "line",
            {
              "dataLn": 6
            },
            [
              "    <",
              [
                "span",
                "pl-c1 di-jsx",
                "Typography"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "component"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "div",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 7
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "Box"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "sx"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              "{ ",
              [
                "span",
                "di-op di-jv",
                "letterSpacing"
              ],
              ": ",
              [
                "span",
                "pl-c1 di-num",
                "6"
              ],
              ", ",
              [
                "span",
                "di-op di-jv",
                "m"
              ],
              ": ",
              [
                "span",
                "pl-c1 di-num",
                "1"
              ],
              " }",
              [
                "span",
                "pl-pse",
                "}"
              ],
              ">Letter Spacing 6px.</",
              [
                "span",
                "pl-c1 di-jsx",
                "Box"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 8
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "Box"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "sx"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              "{ ",
              [
                "span",
                "di-op di-jv",
                "letterSpacing"
              ],
              ": ",
              [
                "span",
                "pl-c1 di-num",
                "10"
              ],
              ", ",
              [
                "span",
                "di-op di-jv",
                "m"
              ],
              ": ",
              [
                "span",
                "pl-c1 di-num",
                "1"
              ],
              " }",
              [
                "span",
                "pl-pse",
                "}"
              ],
              ">Letter Spacing 10px.</",
              [
                "span",
                "pl-c1 di-jsx",
                "Box"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 9
            },
            [
              "    </",
              [
                "span",
                "pl-c1 di-jsx",
                "Typography"
              ],
              ">"
            ]
          ],
          "\n"
        ]
      ]
    },
    "totalLines": 11,
    "focusedLines": 4,
    "collapsible": true,
    "externals": [
      "@mui/material/Typography",
      "@mui/material/Box"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
